import React, { useEffect, useState } from "react";
import { Box, Stack, Typography,CardMedia } from '@mui/material';
import bg from "../imgs/YouTube_1664960000896_1664960001088_1664960001088.jpg"
// import HeroBannerImage from '../assets/images/banner.png';
import { Videos, Sidebar ,Side,SlideVideo,SlideVideoCard,Loader} from "./";

import { useNavigate } from "react-router-dom";


const HeroBanner = ({topVideos}) => {
    const [ change, setChange ] = useState(true);
    const [currentIndex, setCurrentIndex] = useState(0);
    const [isChecked, setIsChecked] = useState(false);
    const [currentVideo, setCurrentVideo] = useState(topVideos[0]);
    const navigate = useNavigate();
    const [counter, setCounter] = useState(0);


    const func=()=>{
        const isLastSlide = currentIndex === topVideos.length - 1;
        const newIndex = isLastSlide ? 0 : currentIndex + 1;
        setCurrentIndex(newIndex)
        setCurrentVideo(topVideos[newIndex] );
    }
    // setInterval(func, 8000);

    // useEffect(()=>{
    //     myTimer()
    // },[])


    const set=(item)=>{
        console.log(item)
        setCurrentVideo(item)


        // clearInterval(myTimer);
        // myTimer = setInterval(func, 8000);

    }

    const onhandleSubmit = (e,currentVideo) => {
        e.preventDefault();

        if (e.target === e.currentTarget) {
            console.log('parent clicked');
            navigate(`/video/${currentVideo?.id?.videoId}`);
            // 👇 your logic here
          }

        
     };
    
    if(!topVideos){
        return <Loader />;
    } 

    return(
    <Box onClick={(e)=>onhandleSubmit(e,currentVideo)} minHeight="90vh" sx= {{position:"relative", "&:hover":"scale(1.5)",transition: "transform .2s", cursor:"pointer", 
        backgroundImage:`linear-gradient(
            rgba(0, 0, 0, 0.7), 
            rgba(0, 0, 0, 0.7)
          ),url(${currentVideo.snippet.thumbnails.high.url})`,
        backgroundRepeat:"no-repeat" ,
        objectFit:"contain", 
        backgroundSize:"cover",
        backgroundPosition:"center",
        alignItems:"center",
        justifyContent:"center"

    }}>
        
        <Box sx={{top:"25%",position:"absolute"}}   overflow="hidden" justposition="relative">

            
            <Typography align = "start" color = "white"  fontWeight={700} mt="10px">
                <h1>{currentVideo.snippet.title}</h1>
            </Typography>
            {/* <SlideVideo videos={topVideos.slice(0, 5)} /> */}
            
        </Box>

        <Stack position="absolute" bottom="2%" marginBottom="5%" direction= "row" flexWrap="wrap" justifyContent="start" alignItems="start" gap={1}>
            {topVideos&&topVideos.slice(0, 5).map((item, idx) => (
            <Box sx={{"&:hover": { backgroundColor:"#A0A0A0" } }} key={idx} onClick={() => set(item)}>
                {/* {item.id.channelId && <ChannelCard channelDetail={item} />} */}
                {item.id.videoId && <SlideVideoCard video={item} /> }
                    
            </Box>
            ))}
        </Stack>
    </Box>
  
)};

export default HeroBanner;